import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  background-color: ${({ theme }) => theme.COLORS.SUB_BACKGROUND};
  padding-bottom: 50px;
`;
export const Title = styled.h1`
  color: ${({ theme }) => theme.COLORS.TITLE};
  font-size: 30px;
  margin-left: 10px;
  font-weight: 700;
  text-align: center;
  margin: 0;
  padding: 10px;

      @media (max-width: 360px) {
       font-size: 17px;
    }
      @media (max-width: 768px) {
       font-size: 20px;
    }
`;
export const Description = styled.h2`
  color: ${({ theme }) => theme.COLORS.TITLE};
  font-weight: 500;
  font-size: 17px;
  margin: 0;
  text-align: center;

  @media (max-width: 360px) {
       font-size: 15px;
    }
     @media (max-width: 768px) {
       font-size: 15px;
    }
`;
export const Content = styled.div`
  width: 95%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
`;
export const ContentLeft = styled.div`
  width: 95%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
export const ContentWrap = styled.div`
  width: 95%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
`;
export const ContainerHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
export const ProgressBar = styled.div`
    width: 98%;
    background-color: #ddd;
    height: 2px;
    margin-top: 10px;
    border-radius: 10px;
    overflow: hidden;
`;
export const Progress = styled.div`
    height: 100%;
    background-color:  ${({ theme }) => theme.COLORS.PRIMARY};
    transition: width 0.3s ease-in-out;
`;
export const ProgressSteps = styled.div`
    font-size: 15px;
    color: ${({ theme }) => theme.COLORS.DESCRIPTION};
`;
export const CardImc = styled.div<{ status: string }>`
  width: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  border-radius: 10px;
  background-color: ${({ theme, status }) => theme.IMC_COLORS[status]};
  cursor: pointer;
  margin-top: 20px;
  padding: 10px;

  @media (max-width: 360px) {
        width: 300px;
    }
     @media (max-width: 768px) {
         width: 300px;
    }
`;
export const SliderImage = styled.img`
    width: 10%;
    height: auto;

    @media (max-width: 360px) {
           width: 30%;
    }
     @media (max-width: 768px) {
            width: 30%;
    }
`;